export default {
  items: [
    {
      name: 'Home',
      url: '/banners-wrapper',
      icon: 'icon-picture',
      children: [{
        name: 'Destaque',
        url: {
          name: 'manageables.index',
          params: { entity: 'general-banners' }
        }
      },
      {
        name: 'Área Genérica',
        url: {
          name: 'manageables.index',
          params: { entity: 'general-other-banners' }
        }
      },
      {
        name: 'Popup',
        url: {
          name: 'manageables.index',
          params: { entity: 'general-popups' }
        }
      }]
    },
    // {
    //   name: 'Produtos',
    //   url: {
    //     name: 'manageables.index',
    //     params: {
    //       entity: 'rte-products'
    //     }
    //   },
    //   icon: 'fa fa-shopping-cart'
    // },
    {
      name: 'Contatos',
      url: '/contacts-wrapper',
      icon: 'icon-envelope',
      children: [{
        name: 'Assuntos',
        url: {
          name: 'manageables.index',
          params: { entity: 'rte-subjects' }
        }
      }, {
        name: 'Fale Conosco',
        url: {
          name: 'manageables.index',
          params: { entity: 'general-contacts' }
        }
      },
      {
        name: 'Leads Campanha de divulgação',
        url: {
          name: 'manageables.index',
          params: { entity: 'rte-campaign' }
        }
      }]
    },
    {
      name: 'Orçamentos',
      url: '/contacts-wrapper',
      icon: 'icon-list',
      children: [{
        name: 'Orçamentos',
        url: {
          name: 'manageables.index',
          params: { entity: 'general-budgets' }
        }
      }, {
        name: 'Exportar XLS',
        url: {
          name: 'manageables.index',
          params: { entity: 'budget-export' }
        }
      }]
    }, {
      name: 'Seguradoras Parceiras',
      url: {
        name: 'manageables.index',
        params: {
          entity: 'rte-partner-insurance-companies'
        }
      },
      icon: 'fa fa-shield'
    },
    {
      name: 'Empresas do grupo',
      url: {
        name: 'manageables.index',
        params: {
          entity: 'rte-group-companies'
        }
      },
      icon: 'fa fa-building-o'
    },
    {
      name: 'Importar Clientes',
      url: {
        name: 'app.rte-customers',
        params: {entity: 'rte-customers'}
      },
      icon: 'fa fa-user-o'
    },
    {
      name: 'Participantes do Sorteio',
      url: {
        name: 'manageables.index',
        params: {
          entity: 'rte-sortition-participants'
        }
      },
      icon: 'fa fa-building-o'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/navbar/default.js